export const GET_WARRANTIES_REPORT = "GET_WARRANTIES_REPORT";
export const RESET_WARRANTIES_REPORT = "RESET_WARRANTIES_REPORT";
export const GET_WARRANTIES_REPORT_SUCCESS = "GET_WARRANTIES_REPORT_SUCCESS";
export const GET_WARRANTIES_REPORT_FAILURE = "GET_WARRANTIES_REPORT_FAILURE";
